import type {ConversationIssueComment} from '../../../page-data/payloads/conversation-comments'

const stableKeyByCommentId = new Map<number, string>()

export function registerIssueCommentKey(id: number, pendingKey: string): void {
  stableKeyByCommentId.set(id, pendingKey)
}

export function issueCommentItemKey(comment: Pick<ConversationIssueComment, 'id'>, fallbackKey: string): string {
  return stableKeyByCommentId.get(comment.id) ?? fallbackKey
}
